module.exports = __webpack_public_path__ + "img/no_img_available.a36ecf55.jpg";